import React from 'react';
import ReactSelectAsync from 'react-select/async';
import defaultTheme from '@styles/theme';

function AsyncSelect(props) {
  const customStyles = {
    container: provided => ({
      ...provided,
      width: '100%'
    }),
    option: (provided, state) => ({
      ...provided,
      color: state.isSelected
        ? defaultTheme.colors.primary
        : defaultTheme.colors.lightText,
      background: defaultTheme.colors.white
    }),
    menuList: () => ({
      background: defaultTheme.colors.white
    }),
    input: () => ({
      padding: 0
    }),
    control: () => ({
      boxShadow:
        'inset 0px 3px 5px 0px rgba(0, 0, 0, 0.1), inset 0px 0px 1px 1px rgba(0, 0, 0, 0.15)',
      focus: {
        boxShadow:
          'inset 0px 3px 5px 0px rgba(16, 107, 87, 0.1), inset 0px 0px 0px 2px rgba(16, 107, 87, 0.25)',
        borderRadius: '4px'
      },
      padding: defaultTheme.space[4],
      borderRadius: 4,
      fontSize: 17,
      background: defaultTheme.colors.white
    }),
    indicatorsContainer: () => ({
      position: 'absolute',
      right: 0,
      top: 8
    }),
    dropdownIndicator: () => ({
      display: 'none'
    }),
    valueContainer: provided => ({
      ...provided,
      padding: 0
    }),
    singleValue: (provided, state) => {
      const opacity = state.isDisabled ? 0.5 : 1;
      const transition = 'opacity 300ms';

      return { ...provided, opacity, transition };
    }
  };

  return <ReactSelectAsync styles={customStyles} {...props} />;
}

export default AsyncSelect;
